import useXoltarNavigation from "../../hooks/useXoltarNav";
import { useCoreAvailability } from "../../hooks/validateCores";
import { useWebValidation } from "../../hooks/websiteValidatioHook";
import BaseCardView from "../../Components/BaseCardView/BaseCardView";
function PrivacyPolicy() {
  const navigate = useXoltarNavigation();
  useWebValidation();
  useCoreAvailability();

  return (
    <BaseCardView
      pageName="Policy"
      dynamicLoad
      cardStyle={{ width: "100%" }}
      bodyComponent={(body: string) => (
        <iframe
          onScroll={(e) => console.debug(e)}
          title="Privacy Policy"
          style={{
            width: "100%",
            minHeight: "20em",
            height: "fit-content",
            maxHeight: "35em",
          }}
          sandbox={""}
          srcDoc={body}
        ></iframe>
      )}
      onNext={() => navigate("Questions")}
      onPrevious={() => navigate("Intro")}
      nextBtnVariant="success"
      prevBtnVariant="danger"
    />
  );
}

export default PrivacyPolicy;
